import { Form } from '@/helpers/Form';
import Pager from '@/helpers/Pager';
import { FilterModel } from "../services/ChatService";

export default {
    namespaced: true,
    state: {
        filter: Form.createPersistedState<FilterModel>({
            name: '',
            propertyPublicId: '',
            cityPublicId: null,
            districtPublicId: null,
            status: ['Active'],
            messageFromUsersIds: ''
        }, undefined, 'renterChatFilter'),
        pager: new Pager(1, 20),
        users: {
            filter: Form.createPersistedState({
                name: ''
            }, undefined, 'renterChatUsersFilter'),
            pager: new Pager(1, undefined, 'Id', 'ASC')
        },
        messages: {
            filter: Form.createPersistedState({
                authorName: '',
                dateFromUtc: null,
                dateToUtc: null,
                message: ''
            }, undefined, 'renterChatMessagesFilter'),
            pager: new Pager(1, undefined, 'DateCreatedUtc', 'DESC')
        },
        removeNotification: null as string
    }
};
